/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Sidebar from "components/sidebar/sidebar";
import { t } from "i18n";
import Menu from "components/menu/menu";
import menuItems from "./menu-items";
import { match } from "react-router";
import { Features } from "api/route-data/route-data";

interface PartialAppState {
  features: Features;
}
interface StateProps {
  enableCollectionsInSidebar?: boolean;
  enablePushNotificationInSidebar?: boolean;
  enableStaticPageInSidebar?: boolean;
  enableFormsInSidebar?: boolean;
}

type Props = StateProps & {
  match: match;
  setActiveSidebar: (type: string) => void;
  isBannerPresent: boolean;
};

export class ContentSidebar extends React.Component<Props> {
  render() {
    return (
      <Sidebar isBannerPresent={this.props.isBannerPresent}>
        <Menu
          items={menuItems({
            enableCollectionsInSidebar: this.props.enableCollectionsInSidebar,
            enablePushNotificationInSidebar: this.props.enablePushNotificationInSidebar,
            enableStaticPageInSidebar: this.props.enableStaticPageInSidebar,
            enableFormsInSidebar: this.props.enableFormsInSidebar
          })}
          getItemLabel={(item) => item.label}
          routeTo={(item) => item.path}
          isItemSelected={(item) => item.path === this.props.match.path || this.props.match.path.includes(item.path)}
          title={t("content.sidebar.title")}
        />
      </Sidebar>
    );
  }
}

const mapStateToProps = (state: PartialAppState): StateProps => {
  return {
    enableCollectionsInSidebar: state.features.enableCollectionsInSidebar,
    enablePushNotificationInSidebar: state.features.enablePushNotificationInSidebar,
    enableStaticPageInSidebar: state.features.enableStaticPageInSidebar,
    enableFormsInSidebar: state.features.canCreateForms
  };
};

export default compose(connect(mapStateToProps))(ContentSidebar);
